export const uploadToCloudinary = async (file) => {
    const url = 'https://api.cloudinary.com/v1_1/dsoj8lhed/upload';
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'plany365_upload');

    const response = await fetch(url, {
        method: 'POST',
        body: formData,
    });

    if (!response.ok) {
        throw new Error('Upload failed');
    }

    const data = await response.json();
    return data.url;
};